import React, { useState } from 'react';
import ReturnMethodDetail from './ReturnMethodDetail';
import { connect } from 'react-redux';
import './OrderReturnNewSCSS/ReturnMethodDetail.scss';
import Button from '../../../../CommonComponents/BootstrapComponents/Button/Button';
// import Check from '../../../../../static/assets/svg/mui-icons/Check.svg';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import { userProperties } from '../../../../CommonComponents/UserPropertiesForGA/UserProperties';

const ReturnOptionTypeMethod = props => {
  const data = sessionStorageHelper.getItem('returnStep') || {};
  const {
    modeOfRefund,
    customerWallet,
    returnMethodsUpdated,
    allModesDisabled,
    addType,
    match,
    location,
    setExchangeMethod,
    singleItemDetail,
    setSelectedSecondaryType,
    setIsExpandable,
    setFourthStep,
    setFinalStep,
    modes,
    dataLocale,
    redisCommonData,
  } = props;
  const { FINAL_CONFIRMATION, REFUND, REFUND_WILL_BE_DONE_IN_LKCASH_WALLET, CONTINUE } = dataLocale;
  const [selectedInput, setSelectedInput] = useState(data?.exchangeMethod || '');
  const [clicked, setClicked] = useState('');
  const [valueSelected, setValueSelected] = useState('');

  const selectedMode = type => {
    setClicked(type);
  };

  const handleSubOptionMode = val => {
    setSelectedInput(val);
  };

  const handleChange = id => {
    userProperties(props.userInfo, 'pc-exchange-options', 'desktop', props.dataLocale);
    addType(id);
    let productToReturn = sessionStorageHelper.getItem('returnProduct') || {};
    productToReturn = {
      ...productToReturn,
      returnAction: id,
    };
    sessionStorageHelper.setItem('returnProduct', productToReturn);
    setValueSelected(id);
  };

  const handleContinue = () => {
    setIsExpandable(FINAL_CONFIRMATION);
    let returnStep = sessionStorageHelper.getItem('returnStep') || {};
    let refundMethod = sessionStorageHelper.getItem('refundMethod') || {};
    returnStep = {
      ...returnStep,
      exchangeMethod: '',
      isExpandable: FINAL_CONFIRMATION,
      exchangeMethodText: '',
      fourthStep: false,
      fifthStep: false,
      finalStep: REFUND,
      refundType: 'customer_wallet',
    };
    let productToReturn = sessionStorageHelper.getItem('returnProduct') || {};
    // cartCallsAction.deleteCart();
    productToReturn = {
      ...productToReturn,
      refundMethod: 'customer_wallet',
    };
    sessionStorageHelper.setItem('returnProduct', productToReturn);
    refundMethod = 'customer_wallet';
    sessionStorageHelper.setItem('refundMethod', refundMethod);
    sessionStorageHelper.removeItem('exchangeMethod');
    sessionStorageHelper.setItem('returnStep', returnStep);
    setSelectedSecondaryType('Customer wallet');
    setFinalStep(REFUND);
  };

  if (!valueSelected) sessionStorageHelper.removeItem('exchangeNP');
  return (
    <>
      <div className="margin-l20 padding-9">
        <div className="display-flex flex-column">
          {returnMethodsUpdated &&
            returnMethodsUpdated.length > 0 &&
            returnMethodsUpdated.map((mode, i) => {
              const widthPercent = mode.id === 'exchange' ? '58%' : '40%';
              return (
                <>
                  <div
                    className={`display-flex align-items-center margin-b10 option-container ${
                      i + 1 === returnMethodsUpdated.length && !(valueSelected === mode.id)
                        ? ''
                        : 'border-bottom'
                    }`}
                  >
                    <div style={{ width: widthPercent }}>
                      <input
                        checked={valueSelected === mode.id}
                        name="return-mode"
                        type="radio"
                        onChange={() => handleChange(mode.id)}
                      />
                      {mode.src && (
                        <img
                          alt="logo"
                          className="margin-8 margin-l25 margin-r20 cursor-pointer"
                          src={mode.src}
                          onClick={() => handleChange(mode.id)}
                        />
                      )}
                      <span className="title" onClick={() => handleChange(mode.id)}>
                        {mode.title}
                      </span>
                      {Boolean(mode.badge) && (
                        <span className="batch return-badge margin-l7">{mode.badge}</span>
                      )}
                    </div>
                    {mode.subText && (
                      <React.Fragment>
                        {mode.subText.type === 'html' ? (
                          <ul
                            className="pd-0 mr-b0 text-color_pale_black margin-b10"
                            style={{ listStyleType: 'none', marginTop: '2px' }}
                          >
                            {mode.subText.contents.map(content => (
                              <div className="display-flex align-items-center">
                                <img
                                  alt="check-icon"
                                  className="margin-r4"
                                  src="https://static.lenskart.com/media/desktop/img/myorder/CheckIcon.svg"
                                />
                                <li
                                  key={content}
                                  className="fsp12 text-color-grey fs10  lh-16"
                                  dangerouslySetInnerHTML={{ __html: content }}
                                ></li>
                              </div>
                            ))}
                          </ul>
                        ) : (
                          <ul
                            className={`pd-0 mr-b0${
                              mode.subText.type !== 'none' ? ' pd-l15' : ''
                            } text-color_pale_black margin-b10`}
                            style={{ listStyleType: mode.subText.type, marginTop: '2px' }}
                          >
                            {mode.subText.contents.map(content => (
                              <div className="display-flex align-items-center">
                                <img
                                  alt="check-icon"
                                  className="margin-r4"
                                  src="https://static.lenskart.com/media/desktop/img/myorder/CheckIcon.svg"
                                />
                                <li
                                  key={content}
                                  className="fsp12 text-color-grey fs10  lh-17"
                                  dangerouslySetInnerHTML={{ __html: content }}
                                ></li>
                              </div>
                            ))}
                          </ul>
                        )}
                      </React.Fragment>
                    )}
                    {!allModesDisabled && mode.error && (
                      <div className="error">
                        {mode.error.status && (
                          <div className="display-flex align-items-center mr-t8">
                            {mode.error.src && (
                              <img
                                alt="img"
                                src={mode.error.src}
                                style={{ width: '16px', height: '16px', flexBasis: '5%' }}
                              />
                            )}
                            <span
                              className="fsp11 mr-l8 lh-14 text-color_dull_black"
                              dangerouslySetInnerHTML={{ __html: mode.error.text }}
                            ></span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {valueSelected === 'refund' && customerWallet && valueSelected === mode.id && (
                    <div className="display-flex align-items-center justify-content-between margin-t12 margin-b14">
                      <div className="fw-bold green-text-color">
                        {REFUND_WILL_BE_DONE_IN_LKCASH_WALLET}
                      </div>
                      <div>
                        <Button
                          className="margin-r10 text-color-white bg-color-primary no-decoration flex-basis-20 text-center block bora-4 fw700 text-uppercase"
                          style={{ width: '200px' }}
                          onClick={handleContinue}
                        >
                          {CONTINUE}
                        </Button>
                      </div>{' '}
                    </div>
                  )}
                  {valueSelected === mode.id && (
                    <ReturnMethodDetail
                      clicked={clicked}
                      customerWallet={customerWallet}
                      dataLocale={dataLocale}
                      handleSubOptionMode={handleSubOptionMode}
                      location={location}
                      match={match}
                      modeOfRefund={modeOfRefund}
                      modes={valueSelected === 'exchange' ? modes : modeOfRefund}
                      redisCommonData={redisCommonData}
                      selectedInput={selectedInput}
                      selectedMode={selectedMode}
                      setExchangeMethod={setExchangeMethod}
                      setFinalStep={setFinalStep}
                      setFourthStep={setFourthStep}
                      setIsExpandable={setIsExpandable}
                      setSelectedSecondaryType={setSelectedSecondaryType}
                      singleItemDetail={singleItemDetail}
                    />
                  )}
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    dataLocale: state.locale,
    userInfo: (state.common.userInfo && state.common.userInfo.result) || null,
  };
}

export default connect(mapStateToProps)(ReturnOptionTypeMethod);
